<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->


<section class="mar-tb-20 pad-lr-15">
  <div class="dta_title pad-btm-30">Create Supply Process Code Exception</div>
  <div class="row ">
    <div class="col-md-4">
      <div class="form-group row">
        <label for="firstName" class="col-sm-6 col-form-label">Delivery Point:
          <span class="required">*</span>
        </label>
        <div class="col-sm-6">
          <select class="form-control" name="delPoint" [(ngModel)]="delPoint" required (ngModelChange)="enableConfigBtn($event);">
            <option value="0">{{'Select' | translate}}</option>
            <option *ngFor="let opt of delPointOpt" [value]="opt">{{opt}}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <button type="button" class="btn btn-dark float-left" (click)="addException()" [disabled]="addConfigBtn">Add Exception</button>
    </div>
    <!-- <div class="col-md-4">
      <div class="form-group row">
        <label for="firstName" class="col-sm-6 col-form-label">Plant:
          <span class="required">*</span>
        </label>
        <div class="col-sm-6">
          <select class="form-control" name="plantName" [(ngModel)]="plantName" #contractType="ngModel" required
            (ngModelChange)="enableConfigBtn($event)">
            <option value="0">{{'Select' | translate}}</option>
            <option *ngFor="let opt of plantNameOpt" [value]="opt">{{opt}}</option>
          </select>
        </div>
      </div>
    </div> -->

  </div>
  <!-- <div class="row">
    <div class="col-md-4">
      <div class="form-group row">
        <label for="description" class="col-sm-6 col-form-label">Description:
          <span class="required">*</span>
        </label>
        <div class="col-sm-6">
          <textarea class="form-control" rows="3" col="200" [(ngModel)]="description" (ngModelChange)="enableConfigBtn($event)"></textarea>
        </div>
      </div>
    </div>
    <div class="col-md-4 pad-top-40">
      <button type="button" class="btn btn-dark float-right" (click)="addException()" [disabled]="addConfigBtn">Add
        Configuration</button>
    </div>
    <div class="col-md-4">
    </div>
  </div> -->
</section>

<div class="dta_title pad-lr-15 mar-top-20 col-md-5">Supply Process Code Exception List</div>
<div class="row no-mar-lr">
  <div class="col-md-6 mar-btm-30">
    <!-- <pagination *ngIf="config.paging" class="pagination-sm pull-right pad-top-10" [(ngModel)]="page" [totalItems]="length"
      [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)"
      (numPages)="numPages = $event">
    </pagination>
    <ng-table [config]="config" (tableChanged)="onChangeTable(config)" [rows]="rows" [columns]="columns" (cellClicked)="onCellClick($event)">
    </ng-table> -->


    
    <pagination *ngIf="config.paging" class="pad-top-10" [(ngModel)]="page" [totalItems]="length"
    [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)"
    (numPages)="numPages = $event">
  </pagination>
    
    <div class="example-container mat-elevation-z8">
    
      <mat-table [dataSource]="dataSource" matSort>
    
       
        <ng-container matColumnDef="deliveryPoint">
          <mat-header-cell *matHeaderCellDef > Delivery Point </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{row.nouba}} </mat-cell>
        </ng-container>
    
      
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef > Action </mat-header-cell>
          <mat-cell *matCellDef="let row"> <div class="hasLink text-center" (click)="onCellClick(row)">Delete</div> </mat-cell>
        </ng-container>
    
       
    
        <mat-header-row *matHeaderRowDef="displayedColumns" ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;">
        </mat-row>
      </mat-table>

      
    </div>
   
    
    <!-- <pre *ngIf="config.paging" class="card card-block card-header">Page: {{page}} / {{numPages}}</pre> -->
  </div>
</div>

<ng-template #deleteDetails let-c="close" let-d="dismiss">
  <div class="modal-body">
    {{'Are you sure you want to delete' | translate }}{{delSelmsg}}
  </div>
  <div class="modal-footer">
    <button type="button" class="col-md-2  btn btn-dark" (click)="deleteRowDetails()">{{'DELETE' | translate}}</button>
    <button type="button" class="col-md-2 btn btn-outline-dark" (click)="c('Close click')">{{'CANCEL' | translate}}</button>
  </div>
</ng-template>